import { match } from 'ts-pattern';
import { FredScale } from '../enums.mjs';

const PERCENT_SCALES = [
    FredScale.Percent,
    FredScale.NetPercentOfBanks,
    FredScale.PercentOfBalances,
    FredScale.PercentOfFirms,
];
const isPercentScale = (scale) => match(scale)
    .with(...PERCENT_SCALES, () => true)
    .otherwise(() => false);
const describeFredChange = (latest, prior, scale) => {
    if (latest === null || latest === undefined)
        return null;
    if (prior === null || prior === undefined)
        return null;
    if (!Number.isFinite(latest) || !Number.isFinite(prior))
        return null;
    const delta = latest - prior;
    if (delta === 0)
        return null;
    const direction = delta > 0 ? "up" : "down";
    const sign = delta > 0 ? "+" : "-";
    const magnitude = Math.abs(delta);
    if (isPercentScale(scale)) {
        return { display: `${sign}${magnitude.toFixed(2)} pts`, direction };
    }
    if (prior <= 0)
        return null;
    const percent = (magnitude / prior) * 100;
    const rounded = percent >= 100 ? Math.round(percent) : Number(percent.toFixed(1));
    return { display: `${sign}${rounded}%`, direction };
};

export { describeFredChange };
